import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import logo from "@/assets/jbnl-logo.png";
import { cn } from "@jbnl/shared-ui";

/**
 * The mark is fixed artwork: place it, never redraw it and never recolour it to match a UI
 * state. White and Brandweer Rood are the only backgrounds it may sit on directly.
 * See the Huisstijlhandboek JBNL 2011 v1.2.
 */
export function Logo({ className, ...props }: ComponentProps<"img">) {
  const { t } = useTranslation();

  return (
    <img
      src={logo}
      alt={t("logoAlt")}
      className={cn("w-auto select-none", className)}
      {...props}
    />
  );
}
